import React, { PropTypes } from 'react';
import Ozitor from 'components/Widgets/Ozitor';
import Constants from 'Constants';
import { FlexBox } from 'components';
import Controls from 'components/PageModule/Controls';
import { PageModuleActions } from 'actions';

import PageModule from 'components/PageModule';
import styles from 'components/Page/Module/Styles';
import debounce from 'oxygen-debounce';

class TextModule extends PageModule {
  static displayName = 'TextModule';

  static contextTypes = {
    getIntlMessage: PropTypes.func,
    media: PropTypes.string
  };

  renderDetailMode() {
    return (
      <div ref={_node => (this._renderNode = _node)} />
      // <div dangerouslySetInnerHTML={{  __html: '<div style="padding: 0.6em">' + this.props.content + '</div>' }} />
    );
  }

  getStyle() {
    const { mouseOver } = this.state;
    const { style, mode } = this.props;
    const margins = {
      marginBottom: 42
    };
    return Object.assign(
      {},
      styles.root,
      margins,
      style,
      mode === 'edit' ? styles.edit : null,
      mode === 'edit' && mouseOver ? styles.hover : null
    );
  }

  createModuleControls() {
    const { mode } = this.props;
    return (
      <Controls
        style={styles.toolbarGroup}
        onSave={::this.save}
        onDelete={::this.askForDelete}
        onEditMode={::this.changeToEditMode}
        mode={mode}
      />
    );
  }

  onEdit() {}

  getContent(content, params) {
    return this.props.content;
  }

  handleChange = content => {
    this.autoSave(content);
  };

  autoSave = debounce(content => {
    const { moduleId: id, data } = this.props;
    PageModuleActions.changePageModule(
      {
        id,
        data: {
          ...data,
          content
        }
      },
      newModule => {
        const { data: newData } = newModule;
        PageModuleActions.savePageModule(
          this.props.moduleId,
          newData.content,
          newData.params
        );
      }
    );
  }, 300);

  componentDidMount() {
    const renderNode = this._renderNode;
    if (renderNode) {
      renderNode.innerHTML = '';
      const div = document.createElement('div');
      try {
        div.innerHTML =
          `<div style="padding: 0.6em">${this.props.content}</div>`;
      } catch (e) {}
      renderNode.appendChild(div);
    }
  }

  componentDidUpdate() {
    const renderNode = this._renderNode;
    if (renderNode) {
      renderNode.innerHTML = '';
      const div = document.createElement('div');
      try {
        div.innerHTML =
          `<div style="padding: 0.6em">${this.props.content}</div>`;
      } catch (e) {}
      renderNode.appendChild(div);
    }
  }

  componentWillUnmount() {
    // this.autoSave.clear();
  }

  onDetail() {
    this.autoSave(this.refs.editor.getValue());
  }

  renderEditMode() {
    const { content } = this.props;
    const extraControls = this.createModuleControls();
    return (
      <Ozitor
        onChange={this.handleChange}
        ref="editor"
        extraControls={extraControls}
        editable={this.props.mode === 'edit'}
        defaultContent={content}
      />
    );
  }

  createControls() {
    const { mode } = this.props;
    if (mode === 'edit') {
      return null;
    }
    return super.createControls();
  }
}

export default TextModule;



// WEBPACK FOOTER //
// ./src/js/components/Page/Module/Text.js